export const PMS_LOCATIONS_SECONDARY_VIEWS = {
    LOCATION_INFO:          "LOCATION_INFO"
};